// extracted by mini-css-extract-plugin
export var fileUpload = "_gr-1";
export var modalButton = "_gr-0";